import { dew as _AbstractParserWithWordBoundaryDew } from "../../../common/parsers/AbstractParserWithWordBoundary";
import { dew as _casualReferencesDew } from "../../../common/casualReferences";
import { dew as _constantsDew } from "../constants";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
      enumerable: true,
      get: function () {
        return m[k];
      }
    });
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function (o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function (o, v) {
    o["default"] = v;
  });
  var __importStar = exports && exports.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const AbstractParserWithWordBoundary_1 = _AbstractParserWithWordBoundaryDew();
  const references = __importStar(_casualReferencesDew());
  const constants_1 = _constantsDew();
  const PATTERN = new RegExp(`(?:с|со)?\\s*(сегодня|вчера|завтра|послезавтра|позавчера)${constants_1.REGEX_PARTS.rightBoundary}`, constants_1.REGEX_PARTS.flags);
  class RUCasualDateParser extends AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking {
    patternLeftBoundary() {
      return constants_1.REGEX_PARTS.leftBoundary;
    }
    innerPattern(context) {
      return PATTERN;
    }
    innerExtract(context, match) {
      const lowerText = match[1].toLowerCase();
      const component = context.createParsingComponents();
      switch (lowerText) {
        case "\u0441\u0435\u0433\u043E\u0434\u043D\u044F":
          return references.today(context.reference);
        case "\u0432\u0447\u0435\u0440\u0430":
          return references.yesterday(context.reference);
        case "\u0437\u0430\u0432\u0442\u0440\u0430":
          return references.tomorrow(context.reference);
        case "\u043F\u043E\u0441\u043B\u0435\u0437\u0430\u0432\u0442\u0440\u0430":
          return references.theDayAfter(context.reference, 2);
        case "\u043F\u043E\u0437\u0430\u0432\u0447\u0435\u0440\u0430":
          return references.theDayBefore(context.reference, 2);
      }
      return component;
    }
  }
  exports.default = RUCasualDateParser;
  //# sourceMappingURL=RUCasualDateParser.js.map
  return exports;
}